{
  "clear": "Jasen",
  "invalid": "(neveljavno)",
  "loading": "Nalaganje...",
  "noResults": "Ni rezultatov"
}
